/*
  World Ready Locale Translations helper file.
  locale data will be passed from server to window. the data will be stored in window.worldReadyData

  This helper will be used to capture the worldReadyData from window and initialize the worldReady module.

 */
import { WorldReady } from '@paypalcorp/worldready';

const worldReadyData = {};

const init = () => {
  try {
    const dataFromServer = (window && window.worldReadyData) || null;

    if (dataFromServer && typeof dataFromServer === 'object') {
      Object.assign(worldReadyData, dataFromServer);
      // paypal-scripts will load worldReady with content automatically during tests
      WorldReady.load(dataFromServer.worldReady);
    }
  } catch (err) {
    console.error('wold-ready-data: load', err);
  }
};

export default worldReadyData;
export { init };
/* eslint no-console:0 */
